const forms = {
  onRequest: "בבקשה", // translated
  person: "אדם", // translated
  travelDate: "תאריך טיול", // translated
  travelDates: "תאריכי נסיעות", // translated
  cancel: "לְבַטֵל", // translated
  getPrice: "קבל מחיר", // translated
};


export default forms;
